module.exports = __webpack_public_path__ + "h5/img/avatar.c22fdd7c.png";